<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch00_fm06"></a><a id="page_vii"><strong><span class="smallcaps">PERFECT COVER</span></strong> </a><a id="page_viii"></a></h2><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?11bc0f7a